import {
  downloadFileData,
  ResponseHeaders,
} from "@tiny/components/src/utils/fileUtils";
import { getSampleCsvData } from "./TinyImporter.helpers";
import { useGetCustomAttributesQuery } from "@tiny/api";

export function useTinyImporterSample() {
  const exportHeaders = {
    "content-disposition": "fileName=ImportSample.csv",
  };

  const { data: customAttributesData } = useGetCustomAttributesQuery();
  const customAttributes =
    customAttributesData?.customAttributeDefinitions ?? [];

  const download = () => {
    downloadFileData(
      new Blob([getSampleCsvData(customAttributes)]),
      exportHeaders as ResponseHeaders
    );
  };

  return {
    download,
  };
}
